<template>
  <div
    class="sm-update-billing__bank"
  >
    <h4>Bank Account</h4>
    <bank-account
      v-if="bankAccount && bankAccount.acc"
      :bankAccount="bankAccount"
      :canDelete="canDelete"
      @default="$emit('default')"
      @update="data => {$emit('add', data)}"
      @delete="showDeleteBank"
    />
    <plaid-wrap
      v-else-if="bankAccount.hasOwnProperty('link')"
      :linkToken="linkToken"
      @success="data => $emit('add', data)"
    >
      <template slot="button">
        <button
          type="button"
          class="sm-update-billing__bank-add"
        >Add Bank Account</button>
      </template>
    </plaid-wrap>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="popup.type == 'delete' ? 'small' : 'large'"
      :class="'sm-update-billing__bank-popup'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <confirm-block
          v-if="popup.type == 'delete'"
          :text="'Bank Account will be deleted'"
          :confirmType="'error'"
          @close="popup.isOpen = false"
          @confirm="confirmDeleteBank"
        />
      </template>
    </popup-block>
  </div>
</template>

<script>
import Popup from '@/components/Popup';
import Confirm from '@/components/Confirm';
import BankAccount from '@/components/bank-account/BankAccount';
import PlaidWrap from '@/components/bank-account/PlaidWrap';

export default {
  name: 'bank-account-wrap',
  components: {
    'popup-block': Popup,
    'confirm-block': Confirm,
    'bank-account': BankAccount,
    'plaid-wrap': PlaidWrap
  },
  props: {
    bankAccount: {},
    canDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: '' // values: delete
      }
    }
  },
  computed: {
    linkToken() {
      if (!this.bankAccount || !this.bankAccount.link)
        return '';

      return this.bankAccount.link.link_token;
    }
  },
  created() {
    
  },
  methods: {
    showDeleteBank() {
      this.popup.type = 'delete';
      this.popup.isOpen = true;
    },
    confirmDeleteBank() {
      this.popup.isOpen = false;
      this.$emit('delete');
    }
  }
}
</script>